module.exports = __webpack_public_path__ + "img/circleBackgrounds.4bf2d0bc.svg";